import React from 'react';

const Hero = () => {
  const heroStyle = {
    backgroundImage: `linear-gradient(
      rgba(26, 83, 118, 0.46), 
      rgba(46, 134, 193, 0.16)
    ), url('/images/hero/background.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background" style={heroStyle}></div>
      <div className="container">
        <div className="hero-content">
          <img src="logo.png" alt="OxyCom Logo" className="about-logo" />
          <h1>Global Commodity Trading & Procurement Solutions</h1>
          <p className="hero-subtitle">
            Your trusted partner in international trade, delivering comprehensive 
            procurement and supply chain solutions across Southern Africa and beyond.
          </p>
          <div className="hero-buttons">
            <a href="/services" className="btn">Our Services</a>
            <a href="/contact" className="btn btn-secondary">Contact Us</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;